module.exports = __webpack_public_path__ + "grass.a29b38c8e46c1269ca2f9736bdfc1961.png";